import { Router } from '@angular/router';

import { URL_ACTION_TRIGGER_BASE_PATH } from './url-action-trigger.types';

const isAnchorElement = (el: any): el is HTMLAnchorElement =>
  el && el.tagName.toLowerCase() === 'a' && el.href;

export function interceptUrlActionTriggerLink(doc: Document, router: Router) {
  doc.addEventListener('click', e => {
    if (isAnchorElement(e.target)) {
      if (e.target.href.includes(URL_ACTION_TRIGGER_BASE_PATH)) {
        const relative = e.target.href.replace(doc.location.origin, '');
        router.navigate([relative]);
        e.preventDefault();
      }
    }
  });
}
